module.exports = __webpack_public_path__ + "static/media/users.9738658b.svg";